<script setup>
    import { defineProps, defineEmits } from 'vue'

    defineProps({
        showModal: {
            type: Boolean,
            required: true
        }
    })

    const emit = defineEmits(['close'])

    const partnersList = [
        'National Debt Relief',
        'Law Offices of Robert S. Gitmeid & Assoc., PLLC',
        'The Credit Pros',
        'Credit Saint',
        'Reach Financial'
    ]

    function hideIfEmpty(event) {
        if (event.target.id === 'turboDebtPartners') {
            emit('close')
        }
    }
</script>

<template>
   <transition name="slide-fade" appear v-cloak>
        <div class="modal fade show" id="turboDebtPartners" tabindex="-1" role="dialog" aria-labelledby="turboDebtPartnersTitle" aria-hidden="true" v-show="showModal" v-cloak @click="hideIfEmpty">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="turboDebtPartnersTitle">TurboDebt Partners</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="$emit('close')"></button>
                    </div>
                    <div class="modal-body">
                        <p><strong>TurboDebt partners include:</strong></p>
                        <ul style="font-size: .9em;" id="partnerList">
                            <li v-for="partner in partnersList" :key="partner">
                                {{ partner }}
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
    .modal {
        display: unset;
    }

    .modal-body {
        max-height: 500px;
        max-height: 80vh;
        overflow: scroll;
    }
</style>
